import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIPromptStep } from './components/AIPromptStep';

async function LoadAIPromptStep(): Promise<typeof AIPromptStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ai-prompt" */ './components/AIPromptStep'))
		.AIPromptStep;
}

export function AIPromptLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIPromptStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIPromptStep = LoadAIPromptStep;
